import React from 'react'

export default function AdminAgentsDetail() {
  return (
    <div style={{height:'25px' , borderWidth:'1px' , borderStyle:'solid'}}>
        AdminAgentsDetail
    </div>
  )
}
